var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-item" }, [
    _c("figure", { staticClass: "line-item-image" }, [
      _c("img", { attrs: { src: _vm.sizedImageSrc, alt: "" } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "line-item-content" }, [
      _c(
        "a",
        { staticClass: "line-item-content-title", attrs: { href: _vm.url } },
        [_vm._v("\n      " + _vm._s(_vm.productTitle) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.variantTitle
        ? _c("span", { staticClass: "line-item-content-subtitle" }, [
            _vm._v("\n      " + _vm._s(_vm.variantTitle) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "line-item-content-price" }, [
        _vm._v(_vm._s(_vm.formattedPrice))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "line-item-actions" }, [
      _c(
        "label",
        {
          staticClass: "line-item-actions-select-label",
          attrs: { for: _vm.handle }
        },
        [_vm._v("\n      " + _vm._s(_vm.translations.quantity) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line-item-actions-select" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentQuantity,
                expression: "currentQuantity"
              }
            ],
            attrs: { id: _vm.handle },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.currentQuantity = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
            _vm._v(" "),
            _vm._l(_vm.currentQuantity + 10, function(n) {
              return _c(
                "option",
                { key: n + _vm.productTitle, domProps: { value: n } },
                [_vm._v("\n          " + _vm._s(n) + "\n        ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "icon-cheveron-down",
            attrs: { viewbox: "0 0 20 20" }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M9.293 12.95l0.707 0.707 5.657-5.657-1.414-1.414-4.243 4.242-4.243-4.242-1.414 1.414z"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "line-item-actions-remove",
          on: {
            click: function($event) {
              return _vm.$emit("remove")
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.translations.remove) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }